import { useGetBadgesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { badgesColumns, type BadgeRow } from '../constants/badgesColumns';

export const BadgesList = () => {
    const { loading: badgesLoading, data: badgesData, error: badgesError } = useGetBadgesQuery();

    if (badgesLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!badgesData || badgesError) {
        throw new Error('Une erreur est survenue lors de la récupération des badges');
    }

    const { badges } = badgesData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<BadgeRow>
                columns={badgesColumns}
                data={badges}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => '/badge/' + row._id}
                searchPlaceholder="Nom du badge"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
